<template>
    <div class="modal fade modal-upload" id="editUser" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">

                <div v-show="(loading == true)" class="loading-backdrop">
                    <div class="loading"></div>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <form class="" @submit.prevent="editUser">
                        <div class="center-modal ex-input-center">
                            <div class="center-ttl text-center">
                                {{ $t('user.edit.title') }}
                            </div>

                            <div class="error-message" v-if="alert_error" data-vv-scope='s1'>
                                <div class="d-flex">
                                    <i class="icon-warning mr-2"></i>
                                    <div class="errror-txt">
                                        <p class="fs-14 text-red font600">{{ $t('error.title') }}</p>
                                        <p class="fs-14 text-red font600">{{ alert_error }}</p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="this.editObj.ids.length > 0" data-vv-scope='s2'>
                                <div class="form-input" v-if="this.editObj.ids.length == 1" data-vv-scope='s3'>
                                    <label class="form-input-lb">
                                        {{ $t('user.general.username') }} <span class="text-red">*</span>
                                    </label>
                                    <!-- <div class="form-input-cnt ex-has-error"> -->
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('username') }">
                                        <input
                                            type="text"
                                            :disabled = "isAdmin"
                                            autocomplete="off"
                                            name="username"
                                            key="username"
                                            v-model="user.username"
                                            class="form-control"
                                            :placeholder="$t('place_holder.username')"
                                            :data-vv-as="$t('user.general.username')"
                                            v-validate.disable="{required:true,min:1,max:100,regex:/^[a-zA-Z0-9@\-_\.]*$/}">
                                        <div v-show="errors.has('username')" class="error-text">{{ errors.first('username') }}</div>
                                    </div>
                                </div>

                                <div class="form-input" v-if="this.editObj.ids.length == 1" data-vv-scope='s4'>
                                    <label class="form-input-lb">
                                        {{ $t('user.general.full_name') }} <span class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('fullName') }">
                                        <input
                                            type="text"
                                            autocomplete="off"
                                            name="fullName"
                                            key="fullName"
                                            v-model="user.fullName"
                                            class="form-control"
                                            :placeholder="$t('place_holder.full_name')"
                                            :data-vv-as="$t('user.general.full_name')"
                                            v-validate.disable="'required|min:1|max:255'">
                                        <div v-show="errors.has('fullName')" class="error-text">{{ errors.first('fullName') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('company.general.full_name') }} <span v-if="this.editObj.ids.length == 1" class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('companyId') }">
                                        <select2
                                                id="companyId"
                                                v-model="user.companyId"
                                                :disabled="isAdmin"
                                                :data-vv-as="$t('company.general.full_name')"
                                                v-validate.disable="this.editObj.ids.length == 1 ? 'required' : ''"
                                                class=""
                                                name="companyId"
                                                key="companyId"
                                                :options="selectCompanyId"
                                                :settings="selectCompanyIdSettings"
                                                @change="selectCompanyIdChangeEvent($event)"
                                                @select="selectCompanyIdEvent($event)"></select2>
                                        <div v-show="errors.has('companyId')" class="error-text">{{ errors.first('companyId') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('group.general.name') }} <span v-if="this.editObj.ids.length == 1" class="text-red">*</span>
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('groupId') }">
                                        <select2
                                                v-model="user.groupId"
                                                :disabled="isAdmin"
                                                :data-vv-as="$t('group.general.name')"
                                                v-validate.disable="this.editObj.ids.length == 1 ? 'required' : ''"
                                                class=""
                                                name="groupId"
                                                key="groupId"
                                                :options="selectGroupId"
                                                :settings="selectGroupIdSettings"
                                                @change="selectGroupIdChangeEvent($event)"
                                                @select="selectGroupIdEvent($event)"></select2>
                                        <div v-show="errors.has('groupId')" class="error-text">{{ errors.first('groupId') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.role') }} <span v-if="this.editObj.ids.length == 1" class="text-red">*</span>
                                    </label>

                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('roleId') }">
                                        <select2
                                                v-model="user.roleId"
                                                :disabled="isAdmin"
                                                class=""
                                                name="roleId"
                                                key="roleId"
                                                :data-vv-as="$t('user.general.role')"
                                                v-validate.disable="this.editObj.ids.length == 1 ? 'required' : ''"
                                                :options="selectRoleId"
                                                :settings="selectRoleIdSettings"
                                                @change="selectRoleIdChangeEvent($event)"
                                                @select="selectRoleIdEvent($event)"></select2>
                                        <div v-show="errors.has('roleId')" class="error-text">{{ errors.first('roleId') }}</div>
                                    </div>
                                </div>

                                <!-- <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.period') }}
                                    </label>
                                    <div class="form-input-cnt">
                                       <date-picker
                                            :placeholder="$t('place_holder.period')"
                                            format="YYYY.MM.DD"
                                            v-model="range_date"
                                            :disabled-date="notBeforeDate"
                                            :editable="false"
                                            range>
                                       </date-picker>
                                    </div>
                                </div> -->
                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('login.password') }}
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('password') }">
                                        <input
                                            :disabled="isAdmin"
                                            type="text"
                                            name="password"
                                            autocomplete="off"
                                            v-model="newPassword"
                                            class="form-control"
                                            :data-vv-as="$t('login.password')">
                                        <div v-show="errors.has('password')" class="error-text">{{ errors.first('password') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.start_date') }}
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('start_date') }">
                                       <date-picker
                                           ref="start_date"
                                           name="start_date"
                                           key="start_date"
                                           :disabled="isAdmin"
                                           :placeholder="$t('place_holder.start_date')"
                                           :data-vv-as="$t('user.general.start_date')"
                                           format="YYYY.MM.DD"
                                           v-validate.disable="'date_format:yyyy.MM.DD'"
                                           v-model="user.validPeriodFrom"
                                           :disabled-date="notBeforeDate"
                                           :editable="false"
                                           @change="changeDate">
                                       </date-picker>
                                       <label class="checkbox-custom mr-4 mt10" v-if="this.editObj.ids.length > 1" data-vv-scope='s5'>
                                            <input type="checkbox" name="allow_edit_start_date" v-model="allowEditStartDate">
                                            <span class="checkmark"></span>
                                            <span>{{ $t('user.general.allow_edit_field') }}</span>
                                        </label>
                                       <div v-show="errors.has('start_date')" class="error-text">{{ errors.first('start_date') }}</div>
                                    </div>
                                </div>

                                <div class="form-input">
                                    <label class="form-input-lb">
                                        {{ $t('user.general.end_date') }}
                                    </label>
                                    <div class="form-input-cnt"
                                        :class="{ 'ex-has-error': errors.has('end_date') }">
                                       <date-picker
                                           ref="end_date"
                                           name="end_date"
                                           key="end_date"
                                           :disabled="isAdmin"
                                           :placeholder="$t('place_holder.end_date')"
                                           :data-vv-as="$t('user.general.end_date')"
                                           format="YYYY.MM.DD"
                                           v-validate.disable="'date_format:yyyy.MM.DD'"
                                           v-model="user.validPeriodTo"
                                           :disabled-date="notBeforeDate"
                                           :editable="false"
                                           @change="changeDate">
                                       </date-picker>
                                       <label class="checkbox-custom mr-4 mt10" v-if="this.editObj.ids.length > 1" data-vv-scope='s6'>
                                            <input type="checkbox" name="allow_edit_end_date" v-model="allowEditEndDate">
                                            <span class="checkmark"></span>
                                            <span>{{ $t('user.general.allow_edit_field') }}</span>
                                        </label>
                                       <div v-show="errors.has('end_date')" class="error-text">{{ errors.first('end_date') }}</div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center mt-4 pt-4">
                                    <div class="pr-2 w-165">
                                        <button type="submit" class="btn btn-pink-53 w-100" :disabled="submitted">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>

                                    <div class="pl-2 w-165">
                                        <button class="btn btn-gray-53 w-100" data-dismiss="modal" type="button" :disabled="submitted">
                                            {{ $t('button.cancel') }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <div class="">
                                    {{ $t('user.general.no_select') }}
                                </div>

                                <div class="d-flex justify-content-center mt-4 pt-4">
                                    <div class="pl-2 w-165">
                                        <button class="btn btn-pink-53 w-100" data-dismiss="modal" type="button">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* global $ */
import _ from 'lodash';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ja';

import UserManagementService from '@/services/admin/user.service';
import GroupManagementService from '@/services/admin/group.service';
import StorageService from "@/services/common/storage.service";
import { AuthService } from "@/services/common/auth.service";

import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils'
import { Role } from '@/helpers/role';
import store from '@/store/index';

export default {
    components: {
        DatePicker,
    },
    name: 'EditUserManagement',
    props: {
        editObj: [Object],
    },
    data () {
        return {

            alert_success: "",
            alert_error: "",

            selectRoleId: [],
            selectRoleIdSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.role'),
                data: this.selectRoleId,
            },

            selectCompanyId: [],
            selectCompanyIdSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.company'),
                data: this.selectCompanyId,
            },

            groups: [],
            selectGroupId: [],
            selectGroupIdSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.group'),
                data: this.selectGroupId,
            },

            user: {
                username: "123",
                fullName: "",
                companyId: "",
                groupId: "",
                roleId: "",
                validPeriodFrom: "",
                validPeriodTo: "",
            },

            newPassword: "",

            loading: false,
            submitted: false,

            allowEditStartDate: false,
            allowEditEndDate: false,

            isAdmin: false,
        };
    },
    beforeCreate () {
        this.$forceUpdate();
    },
    created () {
        this.resetModal();
        this.getAllRoles();
    },
    beforeMount () {
    },
    mounted () {
        this.isAdmin = Utils.isAdmin();
        let _this = this;
        $("#editUser").on('show.bs.modal', function () {
            _this.getAllCompanies();
            _this.getAllGroups();
            _this.detailUser();
            store.commit('loading', false);
        });
        $("#editUser").on('hide.bs.modal', function () {
            _this.resetModal();
            // _this.$emit('unSlectAllUser');
            store.commit('loading', false);
        });
    },
    computed: {
    },
    watch: {
    },
    methods: {
        resetModal: function resetModal () {
            this.user = {
                username: "",
                fullName: "",
                groupId: "",
                roleId: "",
                validPeriodFrom: "",
                validPeriodTo: "",
            };

            this.alert_success = "";
            this.alert_error = "";
            this.submitted = false;
            this.loading = false;

            this.allowEditStartDate = false;
            this.allowEditEndDate = false;

            this.newPassword = "";

            this.$validator.reset();
        },

        editUser (e) {
            if (this.editObj.ids.length < 0) {
                return false;
            }

            if (this.newPassword.length > 0) {
                var reg = /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[<>{}()\-+*/_!$%&#?@;:,.])[a-zA-Z0-9<>{}()\-+*/_!$%&#?@;:,.]{8,}$/;
                if (!reg.test(this.newPassword)) {
                    this.$validator.errors.add({
                        field: 'password',
                        msg: this.$t('error.error_password'),
                    });
                    this.submitted = false;
                    return false;
                } else {
                    this.user.password = this.newPassword;
                }
            }

            Utils.trimObject(this.user);

            this.submitted = true;

            this.$validator.validate().then(valid => {
                let flag = true;

                if (!DateUtils.compareDate(this.user.validPeriodFrom, this.user.validPeriodTo)) {
                    if ((this.editObj.ids.length == 1) || (this.editObj.ids.length > 1 && this.allowEditStartDate && this.allowEditEndDate)) {
                        this.$validator.errors.add({
                            field: 'start_date',
                            msg: this.$t('error.error_before_date', { date: this.$t('user.general.start_date') }),
                        });
                        flag = false;
                    }
                } else {
                    this.errors.remove("start_date");
                    this.errors.remove("end_date");
                    flag = true;
                }

                if (!valid || !flag) {
                    this.submitted = false;
                    return false;
                }

                this.loading = true;

                UserManagementService.editUser(this.editObj.ids, this.user, this.allowEditStartDate, this.allowEditEndDate)
                    .then(response => {
                        if (response.status == 423) {
                            StorageService.saveExpired();
                            AuthService.doLogout();
                        }
                        if (response.status == 200) {
                            this.alert_success = this.$t('success.update_success');
                            this.alert_error = "";
                            this.$toasted.success(this.alert_success, {icon: 'fa-check'});
                            this.$emit('updateListUser');
                            this.$emit('unSlectAllUser');

                            $('#editUser').modal('hide');
                            $('.modal-backdrop').remove();
                        } else {
                            this.alert_success = "";
                            this.alert_error = this.$t('fail.update_fail');

                            let errorCode = Utils.getErrorCode(response);
                            if (errorCode) {
                                this.alert_error = this.$t('error.error_code_' + errorCode);
                            }

                            // this.$toasted.error(this.alert_error, {icon: 'fa-exclamation-triangle'});
                        }

                        if (response.status == 403) {
                            this.alert_success = "";
                            this.alert_error = this.$t('error.error_' + response.status);
                        }

                        this.loading = false;
                        this.submitted = false;
                        this.$validator.reset();
                    }).catch(error => {
                        this.alert_success = "";
                        this.alert_error = this.$t('fail.update_fail');

                        // $('#editUser').modal('hide');
                        // $('.modal-backdrop').remove();
                        // this.$toasted.error(this.alert_error, {Icon: 'fa-exclamation-triangle'});

                        this.loading = false;
                        this.submitted = false;
                        this.$validator.reset();
                    });
            });
        },

        detailUser: function detailUser () {
            if (this.editObj.ids.length != 1) {
                return false;
            }

            UserManagementService.detailUser(this.editObj.ids[0])
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        this.user.username = response.data.username;
                        this.user.fullName = response.data.full_name;
                        this.user.companyId = response.data.company_id;
                        this.user.groupId = response.data.group_id;
                        this.user.roleId = response.data.role_id;

                        if (!Utils.isEmptyStr(response.data.valid_period_from)) {
                            this.user.validPeriodFrom = new Date(response.data.valid_period_from);
                        } else {
                            this.user.validPeriodFrom = "";
                        }

                        if (!Utils.isEmptyStr(response.data.valid_period_to)) {
                            this.user.validPeriodTo = new Date(response.data.valid_period_to);
                        } else {
                            this.user.validPeriodTo = "";
                        }
                    } else {
                        this.user.username = "";
                        this.user.fullName = "";
                        this.user.groupId = "";
                        this.user.roleId = "";
                        this.user.validPeriodFrom = "";
                        this.user.validPeriodTo = "";
                    }
                }).catch(error => {
                    this.user.username = "";
                    this.user.fullName = "";
                    this.user.groupId = "";
                    this.user.roleId = "";
                    this.user.validPeriodFrom = "";
                    this.user.validPeriodTo = "";
                });

            return false;
        },

        getAllRoles: function getAllRoles () {
            let userRole = StorageService.getUserRole();

            let _dataSelect = [];
            $.each(Role, function (key, value) {
                if (value.id >= userRole) {
                    let item = {
                        id: value.id,
                        text: value.name,
                    };
                    _dataSelect.push(item);
                }
            });
            this.selectRoleId = _dataSelect;
        },

        getAllCompanies: function getAllCompanies () {
            GroupManagementService.getAllCompanies()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return ;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                            };
                            _dataSelect.push(item);
                        });

                        this.selectCompanyId = _dataSelect;
                    } else {
                        this.selectCompanyId = [];
                    }
                }).catch(error => {
                    this.selectCompanyId = [];
                });
            return ;
        },

        getAllGroups: function getAllGroups () {
            GroupManagementService.getAllGroups()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (Utils.isEmptyStr(value.branch_name) && Utils.isEmptyStr(value.department_name) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let text = "";
                            if (!Utils.isEmptyStr(value.branch_name)) {
                                text += value.branch_name;
                            }
                            if (!Utils.isEmptyStr(value.department_name)) {
                                text += "・" + value.department_name;
                            }
                            if (!Utils.isEmptyStr(value.name)) {
                                text += "・" + value.name;
                            }

                            let item = {
                                id: value.id,
                                text: text,
                                company_id: value.company_id,
                            };
                            _dataSelect.push(item);
                        });

                        this.selectGroupId = _dataSelect;
                        this.groups = _dataSelect;
                    } else {
                        this.selectGroupId = [];
                        this.groups = [];
                    }
                }).catch(error => {
                    this.selectGroupId = [];
                    this.groups = [];
                });
            return false;
        },

        selectRoleIdChangeEvent (val) {
        },

        selectRoleIdEvent ({id, text}) {
        },

        selectGroupIdChangeEvent (val) {
        },

        selectGroupIdEvent ({id, text}) {
        },

        selectCompanyIdChangeEvent (val) {
            if (Utils.isEmptyStr(val)) {
                this.selectGroupId = this.groups;
                return ;
            }
            const _groupRefer = _.filter(this.groups, function (n) {
                return  n.company_id == val;
            });
            this.selectGroupId = _groupRefer;
        },

        selectCompanyIdEvent ({id, text}) {
        },

        notBeforeDate (date) {
            let today = new Date();
            today.setDate(new Date().getDate() - 1);
            return date <= today;
        },

        changeDate (date) {
            /*
                this.errors.remove("start_date");
                this.errors.remove("end_date");

                if(!Utils.compareDate(this.user.validPeriodFrom, this.user.validPeriodTo)) {
                    this.$validator.errors.add({
                        scope: this.$options.scope,
                      field: 'start_date',
                      msg: this.$t('error.error_before_date', { date: this.$t('user.general.start_date')})
                    });
                }
                */
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/UserManagement/Edit.vue